module.exports = __webpack_public_path__ + "img/13.4ae659a6.png";